import { getFullDateTime } from '@news-mono/web-common'
import React from 'react'
import { StyledSharingWrap } from '../../bauhaus/BauhausHeroCard/BauhausHeroCard.styled'
import { Sharing } from '../../buttons/Sharing/Sharing'
import {
    StyledStaticByLine,
    StyledStaticByLineLink,
    StyledStaticHr,
    StyledStaticShareByLine,
} from './StaticHeroByLine.styled'

export interface StaticHeroByLineProps {
    byLine: { title: string; linkText: string; linkUrl: string }
    share: { url: string; text: string }
    lastUpdated?: string
}

export const StaticHeroByLine = ({
    byLine,
    share,
    lastUpdated,
}: StaticHeroByLineProps) => {
    return (
        <StyledStaticShareByLine>
            <StyledStaticByLine>
                {byLine.title}
                <span> / </span>
                {lastUpdated ? (
                    `Updated ${getFullDateTime(lastUpdated)}`
                ) : (
                    <StyledStaticByLineLink to={byLine.linkUrl}>
                        {byLine.linkText}
                    </StyledStaticByLineLink>
                )}
            </StyledStaticByLine>
            <StyledStaticHr />

            <StyledSharingWrap className="StyledSharingWrap">
                <Sharing
                    className="BauhausCardSharing"
                    url={share.url}
                    text={share.text}
                    isGhostStyle={true}
                    onEvent={() => {}}
                    shareOptions={['twitter', 'facebook', 'clipboard']}
                    isBauhaus={true}
                />
            </StyledSharingWrap>
        </StyledStaticShareByLine>
    )
}
